"use client"

import { Maybe } from "@instacover/utils"
import { useState } from "react"

import { Button } from "@/components/shadcn/Button"
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/shadcn/Select"
import { Spacer } from "@/components/Spacer"
import { devtoolsLoginAction } from "@/server/auth/devtoolsLoginAction"
import { logoutAction } from "@/server/auth/logoutAction"

type Props = {
  users: { email: Maybe<string>; id: string }[]
  onClose: () => void
}

export function DevtoolsImpersonate(props: Props) {
  const { users, onClose } = props

  const [email, setEmail] = useState("")

  return (
    <>
      <h6 className="text-sm font-semibold text-slate-800">Impersonate user</h6>

      <Spacer className="h-2" />

      <div>
        <Select value={email} onValueChange={setEmail}>
          <SelectTrigger>
            <span className="max-w-[280px] truncate">
              <SelectValue placeholder="Email" />
            </span>
          </SelectTrigger>

          <SelectContent>
            {users.map((user) => {
              if (!user.email) {
                return null
              }
              return (
                <SelectItem key={user.email} value={user.email}>
                  {user.email}
                </SelectItem>
              )
            })}
          </SelectContent>
        </Select>

        <Spacer className="h-4" />

        <div className="flex justify-end gap-3">
          <Button
            size="sm"
            onClick={async () => {
              try {
                await logoutAction({})
              } finally {
                onClose()
              }
            }}
          >
            Odhlásit
          </Button>

          <Button
            size="sm"
            disabled={!email}
            type="button"
            onClick={async () => {
              try {
                await devtoolsLoginAction({ email })
              } finally {
                onClose()
              }
            }}
          >
            Login
          </Button>
        </div>
      </div>
    </>
  )
}
